(function () {
    angular
        .module('dashboard')
        .component('outOfStock',
            {
                templateUrl: 'components/store/out-of-stock/out-of-stock.7423f640.html',
                bindings: {},
                controller: [
                    '$scope',
                    '$state',
                    '$uibModal',
                    'PermissionService',
                    'APIService',
                    'DashboardConfig',
                    'LocalisationService',
                    'ErrorService',
                    'notify',
                    '$timeout',
                    OutOfStockComponent ]
            });

    function OutOfStockComponent(
        $scope,
        $state,
        $uibModal,
        PermissionService,
        APIService,
        DashboardConfig,
        LocalisationService,
        ErrorService,
        notify,
        $timeout) {
        this.errorService = ErrorService;
        this.apiService = APIService;
        this.permissionService = PermissionService;
        this.notify = notify;
        this.config = DashboardConfig;
        this.uibModal = $uibModal;
        this.$state = $state;
        this.$scope = $scope;
        this.$timeout = $timeout;

        this.dateTimeFormat = LocalisationService.Configuration.DateTimeFilterFormat;

        this.storeName = PermissionService.userContext.getCurrentContextName();
        this.storeId = this.permissionService.userContext.StoreId;
        this.selectedCodes = [];
        this.selectedMenuItemOptions = [];

        this.selectedExpiryDays = 0;
        this.requestedItemExpiryDays = 0;
        this.requestedItemName = "";
        this.requestedItemDescription = "";

        this.maxExpiryDays = 0;
        this.menuItems = [];
        this.outOfStockItems = [];
        this.expiryDaysOptions = [];
        this.previousRequests = [];
        this.selectedScript = null;
        this.showReqeustScreen = false;
        this.disableRequestButton = false;
        this.storeMenuUrl = "";

        checkPermission(PermissionService);
        this.initialise();
    }

    function checkPermission(permissionService) {
        const hasPermission = permissionService
            .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.OutOfStock);

        if (!hasPermission) {
            permissionService.navigateToAccessDenied();
        }
    }

    OutOfStockComponent.prototype = {
        initialise: function () {
            this.apiService.OutOfStock.getModel(this.permissionService.userContext.StoreId)
                .then(result => {
                    this.maxExpiryDays = result.data.MaxExpiryDays;
                    this.selectedExpiryDays = result.data.MaxExpiryDays;
                    this.requestedItemExpiryDays = result.data.MaxExpiryDays;

                    for (i = 1; i <= this.maxExpiryDays; i++) {
                        this.expiryDaysOptions.push(i);
                    }

                    this.scripts = _.reject(result.data.Scripts, function (item) {
                        return item.TopLevelMenuItems.length === 0
                            && item.MenuItemOptions.length === 0
                    });
                    this.scripts = _.sortBy(this.scripts, 'Description');

                    if (this.scripts.length) {
                        this.selectedScript = this.scripts[0];
                    }

                    this.outOfStockItems = result.data.OutOfStockItems;
                });
            this.apiService.OutOfStock.getPreviousRequests(this.permissionService.userContext.StoreId)
                .then(result => {
                    this.previousRequests = result.data;
                });
            this.apiService.Stores.getMenuUrl(this.storeId)
                .then(result => {
                    this.storeMenuUrl = result.data;
                });
        },
        scriptAlreadyExists: function () {
            return _.find(this.outOfStockItems, (item) => {
                return item.Id === this.selectedScript.Id;
            })
        },
        addMenuScript: function () {
            if (this.scriptAlreadyExists()) {
                this.errorService.showError('The selected script already exists.');
                return;
            }

            const associateScript = () => {
                this.apiService.OutOfStock.associateStoreToMenuScript(
                    this.storeId,
                    this.selectedScript.MenuScriptGuid,
                    this.selectedExpiryDays
                );

                this.selectedScript.ActivationDate = new moment();
                this.selectedScript.ExpiryDate = new moment().add(this.selectedExpiryDays, "days");
                this.selectedScript.UserFirstName = this.permissionService.user.FirstName;
                this.selectedScript.UserLastName = this.permissionService.user.LastName;
                this.selectedScript.DisplayItems = this.selectedScript.TopLevelMenuItems
                    .concat(this.selectedScript.MenuItemOptions);
                this.outOfStockItems.push(this.selectedScript);
            }

            if (localStorage.getItem("do-not-show-hide-menu-items")) {
                associateScript();
                return;
            }

            this.uibModal.open({
                animation: true,
                templateUrl: 'components/store/out-of-stock/hide-menu-items-modal.8d1b9f21.html',
                controller: 'HideMenuItemsModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    numItems: () => {
                        return _.uniq(this.selectedScript.TopLevelMenuItems).length;
                    },
                    numOptions: () => {
                        return _.uniq(this.selectedScript.MenuItemOptions).length;
                    },
                    callback: () => {
                        return () => associateScript();
                    }
                }
            });
        },
        expandItems: function (codes) {
            this.uibModal.open({
                animation: true,
                templateUrl: 'components/store/out-of-stock/expand-out-of-stock-codes-modal.e8388ce3.html',
                controller: 'ExpandOutOfStockCodesModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    items: () => {
                        return codes;
                    }
                }
            });
        },
        unique: function (items) {
            return _.uniq(items);
        },
        displayItems: function () {
            if (!this.selectedScript
                || !this.selectedScript.TopLevelMenuItems) {
                return "";
            }

            return _.uniq(this.selectedScript.TopLevelMenuItems).join(', ');
        },
        displayOptions: function () {
            if (!this.selectedScript
                || !this.selectedScript.MenuItemOptions) {
                return "";
            }

            return _.uniq(this.selectedScript.MenuItemOptions).join(', ');
        },
        viewMenu: function () {
            window.open(this.storeMenuUrl);
        },
        cancelMenuScript: function (script) {
            this.apiService.OutOfStock.cancelMenuScript(
                this.storeId,
                script.MenuScriptGuid
            );
            this.outOfStockItems = this.outOfStockItems.filter((item) => {
                return item.MenuScriptGuid !== script.MenuScriptGuid
            })
        },
        request: function () {
            this.showReqeustScreen = true;
        },
        goBackFromRequest: function () {
            this.showReqeustScreen = false;
        },
        requestNewItem: async function () {
            this.disableRequestButton = true;
            try {
                await this.apiService.OutOfStock.submitRequest(
                    this.storeId,
                    this.requestedItemName,
                    this.requestedItemDescription,
                    this.requestedItemExpiryDays
                );
                this.previousRequests.push({
                    // We just need a temporary ID until the page is refreshed to avoid angular complaining about id conflicts
                    Id: new moment(),
                    RequestedDate: new moment(),
                    Name: this.requestedItemName,
                    Description: this.requestedItemDescription,
                    UserFirstName: this.permissionService.user.FirstName,
                    UserLastName: this.permissionService.user.LastName,
                });
                this.notify.success("The request has been sent successfully")
                this.$timeout(() => {
                    this.requestedItemName = undefined;
                    this.requestedItemDescription = undefined;
                })
            } catch (e) {
                this.notify.error('There was an issue submitting this request', e)
            } finally {
                this.disableRequestButton = false;
            }
        },
        submitRequest: function () {
            if (!this.requestedItemName
                || !this.requestedItemDescription) {
                this.errorService.showError('Please complete entries for both \'What is out of stock?\' and \'Please list items to mark out of stock\'.');
                return;
            }

            if (localStorage.getItem("do-not-show-request-new-item")) {
                return this.requestNewItem();
            }

            this.uibModal.open({
                animation: true,
                templateUrl: 'components/store/out-of-stock/request-new-item-modal.dae93aa4.html',
                controller: 'RequestNewItemModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    callback: () => this.requestNewItem.bind(this)
                }
            });
        }
    }
})();
